module.exports = __webpack_public_path__ + "static/media/glowrider.c1c65da7.jpg";